export const errorCodes = {
	AUTH_REQUIRED: 'AUTHORIZATION_REQUIRED',
	INVALID_TOKEN: 'invalid_token',
};
